// ##### 24-05-29 Komarov
import { SET_SITE_PAGE_LIST_SECTION } from '../constants';

export default (state = [], action) => {
  switch (action.type) {
    case SET_SITE_PAGE_LIST_SECTION:
      return action.payload;
    default:
      return state;
  }
};
